/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { maxPayByBonusesRequestSchema } from "./maxPayByBonusesRequestSchema.ts";

export const requestRepeatMobileOrderRequestSchema = maxPayByBonusesRequestSchema;
